<template>
  <div id="app">
    <Head></Head>
    <div class="main">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
  </div>
</template>

<script>
// @ts-nocheck
import Head from "@/components/Head"
export default {
  components: {
    Head
  },
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 解决登陆成功后重新加载当前页面方法
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
}
</script>
<style>
html{
  overflow-y: scroll;
}
</style>

<style lang="scss" scoped>

.main{
  margin-top: 56px;
}
</style>
